
    import '/mnt/docs/guide/design.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/design.md?type=demo')
};